// src/components/common/LinkifyText.js

import React from 'react';

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

/**
 * Component that takes a string and renders it with clickable links.
 * @param {Object} props
 * @param {string} props.text - The text to be linkified.
 * @param {string} [props.className] - Optional CSS class for the wrapper.
 * @param {string} [props.linkClassName] - Optional CSS class for the links.
 */
export default function LinkifyText({ text, className = "", linkClassName = "text-cyan-400 hover:text-cyan-300 underline" }) {
    if (!text || typeof text !== 'string') return <span className={className}>{text}</span>;

    const parts = text.split(URL_REGEX);

    return (
        <span className={className}>
            {parts.map((part, i) => {
                if (part.match(URL_REGEX)) {
                    return (
                        <a
                            key={i}
                            href={part}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={linkClassName}
                            onClick={(e) => e.stopPropagation()} // Prevent triggering parent click events
                        >
                            {part}
                        </a>
                    );
                }
                return part;
            })}
        </span>
    );
}
